import { render } from "./TreatmentDialog.vue?vue&type=template&id=7f9b27da&scoped=true&ts=true"
import script from "./TreatmentDialog.vue?vue&type=script&lang=ts"
export * from "./TreatmentDialog.vue?vue&type=script&lang=ts"

import "./TreatmentDialog.vue?vue&type=style&index=0&id=7f9b27da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9b27da"]])

export default __exports__